import { Navigate, useLocation } from "react-router-dom";
import useAuthentication from "../hooks/useAuthentication";
import { CircularProgress } from "@mui/material";
import { frontendRoutes } from "../utility/frontendRoutes";

const ProtectedRoute = ({ children }) => {
  const { isLoggedIn, isLoggingIn, isInitializing } = useAuthentication();
  const location = useLocation();

  if (isInitializing || isLoggingIn) {
    return <CircularProgress size={20} />;
  }
  if (!isLoggedIn) {
    return (
      <Navigate to={frontendRoutes.LOGIN} state={{ from: location }} replace />
    );
  }
  return children;
};

export default ProtectedRoute;
